export default function guestFunctionality() {
  removePriceForGuestUsers();
}

function removePriceForGuestUsers() {
  if ($('body').hasClass('guest')) {
    $('.quantity, .single_add_to_cart_button, .bundled_item_qty_col').remove();
  }
}
